import {
  CHANNEL_OVERLAP, CROSS_CHANNEL_REPORT,
  DATA_WAREHOUSE, EVENT_STATUS, FUNNEL_POSITION, GOOGLE_SHEETS_PLUGIN, INTEGRATIONS,
  MARKETING_MIX_MODELING, MARKETING_PATHS, PLATFORM_PERFORMANCE, PLATFORM_PERFORMANCE_BENCHMARKS, PROMO_CODES, ROCKERBOX_PERFORMANCE, SPEND_TRENDS,
  SURVEYS, TESTING, UNIFIED,
} from './views';

// PERMISSIONS in RBAC (Oso Policy)
// USER MANAGEMENT
export const RBAC_CREATE_CUSTOM_ROLE = 'user_management.create_custom_role';
export const RBAC_ASSIGN_ROLES = 'user_management.assign_roles';

// EMAIL SUBSCRIPTIONS
export const RBAC_EMAIL_SUBSCRIPTIONS_READ = 'email_subscriptions.read';
export const RBAC_EMAIL_SUBSCRIPTIONS_EDIT = 'email_subscriptions.edit';
export const RBAC_EMAIL_SUBSCRIPTIONS_RECEIVE = 'email_subscriptions.receive';

// UI Views
export const RBAC_UI_VIEWS_DATA_INTEGRATIONS = 'ui_views.data.integrations';
export const RBAC_UI_VIEWS_DATA_PROMO_CODES = 'ui_views.data.promo_codes';
export const RBAC_UI_VIEWS_DATA_SURVEYS = 'ui_views.data.surveys';
export const RBAC_UI_VIEWS_DATA_GOOGLE_SHEETS_PLUGIN = 'ui_views.data.google_sheets_plugin';
export const RBAC_UI_VIEWS_DATA_DATA_WAREHOUSE = 'ui_views.data.data_warehouse_sync';
export const RBAC_UI_VIEWS_DATA_EVENT_STATUS = 'ui_views.data.event_status';
export const RBAC_UI_VIEWS_ATTRIBUTION_CROSS_CHANNEL_REPORT = 'ui_views.attribution.cross_channel_report';
export const RBAC_UI_VIEWS_ATTRIBUTION_PLATFORM_PERFORMANCE = 'ui_views.attribution.platform_performance';
export const RBAC_UI_VIEWS_ATTRIBUTION_RB_PERFORMANCE = 'ui_views.attribution.rockerbox_performance';
export const RBAC_UI_VIEWS_JOURNEY_MARKETING_PATHS = 'ui_views.journey.marketing_paths';
export const RBAC_UI_VIEWS_JOURNEY_FUNNEL_POSITION = 'ui_views.journey.funnel_position';
export const RBAC_UI_VIEWS_JOURNEY_CHANNEL_OVERLAP = 'ui_views.journey.channel_overlap';
export const RBAC_UI_VIEWS_TESTING_TESTING = 'ui_views.testing.testing';
export const RBAC_UI_VIEWS_UNIFIED_UNIFIED = 'ui_views.mmm.marketing_mix_modeling'; // UPDATE IN OSO to correct view name
export const RBAC_UI_VIEWS_MMM_MARKETING_MIX_MODELING = 'ui_views.mmm.marketing_mix_modeling';
export const RBAC_UI_VIEWS_BENCHMARKS_SPEND_TRENDS = 'ui_views.benchmarks.spend_trends';
export const RBAC_UI_VIEWS_BENCHMARKS_PERFORMANCE_BENCHMARKS = 'ui_views.benchmarks.performance_benchmarks';

// UI Features
export const RBAC_UI_FEATURES_DOWNLOAD_CSV = 'ui_features.download_csv';

// INTEGRATIONS
export const RBAC_INTEGRATIONS_PLATFORM_ADWORDS = 'integrations.platform.adwords';
export const RBAC_INTEGRATIONS_PLATFORM_BING = 'integrations.platform.bing';
export const RBAC_INTEGRATIONS_PLATFORM_FACEBOOK = 'integrations.platform.facebook';
export const RBAC_INTEGRATIONS_PLATFORM_LINKEDIN = 'integrations.platform.linkedin';
export const RBAC_INTEGRATIONS_PLATFORM_PINTEREST = 'integrations.platform.pinterest';
export const RBAC_INTEGRATIONS_PLATFORM_SNAPCHAT = 'integrations.platform.snapchat';
export const RBAC_INTEGRATIONS_PLATFORM_TIKTOK = 'integrations.platform.tiktok';

export const RBAC_SYSTEM_ROLES = ['admin', 'member'];
export const RBAC_UI_VIEWS_MAPPING = {
  [RBAC_UI_VIEWS_DATA_INTEGRATIONS]: INTEGRATIONS,
  [RBAC_UI_VIEWS_DATA_PROMO_CODES]: PROMO_CODES,
  [RBAC_UI_VIEWS_DATA_SURVEYS]: SURVEYS,
  [RBAC_UI_VIEWS_DATA_GOOGLE_SHEETS_PLUGIN]: GOOGLE_SHEETS_PLUGIN,
  [RBAC_UI_VIEWS_DATA_DATA_WAREHOUSE]: DATA_WAREHOUSE,
  [RBAC_UI_VIEWS_DATA_EVENT_STATUS]: EVENT_STATUS,
  [RBAC_UI_VIEWS_ATTRIBUTION_CROSS_CHANNEL_REPORT]: CROSS_CHANNEL_REPORT,
  [RBAC_UI_VIEWS_ATTRIBUTION_PLATFORM_PERFORMANCE]: PLATFORM_PERFORMANCE,
  [RBAC_UI_VIEWS_ATTRIBUTION_RB_PERFORMANCE]: ROCKERBOX_PERFORMANCE,
  [RBAC_UI_VIEWS_JOURNEY_MARKETING_PATHS]: MARKETING_PATHS,
  [RBAC_UI_VIEWS_JOURNEY_FUNNEL_POSITION]: FUNNEL_POSITION,
  [RBAC_UI_VIEWS_JOURNEY_CHANNEL_OVERLAP]: CHANNEL_OVERLAP,
  [RBAC_UI_VIEWS_TESTING_TESTING]: TESTING,
  [RBAC_UI_VIEWS_UNIFIED_UNIFIED]: UNIFIED,
  [RBAC_UI_VIEWS_MMM_MARKETING_MIX_MODELING]: MARKETING_MIX_MODELING,
  [RBAC_UI_VIEWS_BENCHMARKS_SPEND_TRENDS]: SPEND_TRENDS,
  [RBAC_UI_VIEWS_BENCHMARKS_PERFORMANCE_BENCHMARKS]: PLATFORM_PERFORMANCE_BENCHMARKS,
};
